<template>
    <label class="osm-checkbox">
        <slot />
        <!-- <input type="checkbox" id="checkbox" v-model="checked"> -->
        <input v-if="!Array.isArray(value)" type="checkbox" :id="id" v-model="selected" />
        <!-- <input type="checkbox" id="jack" value="Jack" v-model="checkedNames"> -->
        <input
            v-if="Array.isArray(value)"
            type="checkbox"
            :id="id"
            :value="val"
            v-model="selected"
        />
        <span class="checkmark"></span>
    </label>
</template>

<script>
export default {
    props: ['value', 'val', 'id'],
    data() {
        return {
            selected: this.value,
        };
    },
    watch: {
        value: function(val) {
            this.selected = val;
        },
        selected: function(val) {
            this.$emit('input', val);
        },
    },
};
</script>

<style lang="scss">
/* Customize the label (the container) */
.osm-checkbox {
    position: relative;
    padding-left: 21px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    color: #2a2a2a;
    font-family: Avenir;
    font-size: 13px;
    font-weight: 500;
    line-height: 18px;

    /* Hide the browser's default checkbox */
    input {
        // position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
        transition: all 0.25s ease-in-out;

        /* On mouse-over, add a grey background color */
        &:hover ~ .checkmark {
            background-color: #ccc;
        }

        /* When the checkbox is checked, add a blue background */
        &:checked ~ .checkmark {
            background-color: #6c3e91;
        }

        /* Show the checkmark when checked */
        &:checked ~ .checkmark:after {
            display: block;
        }
    }

    /* Create a custom checkbox */
    .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 14px;
        width: 14px;
        border: 1px solid #9ca5b0;
        border-radius: 2px;
        transition: all 0.25s ease-in-out;

        /* Create the checkmark/indicator (hidden when not checked) */
        &:after {
            content: '';
            position: absolute;
            display: none;
            /* Style the checkmark/indicator */
            left: 4px;
            top: 0px;
            width: 4px;
            height: 8px;
            border: solid white;
            border-width: 0 3px 3px 0;
            -webkit-transform: rotate(45deg);
            -ms-transform: rotate(45deg);
            transform: rotate(45deg);
        }
    }
}
</style>
